import type * as React from 'react';
import { useIntl } from 'react-intl';

import type { VitaProfessionalExperienceFragment } from '@xing-com/crate-lebenslauf-graphql';

import { formatRangeDate } from './template-format-range-date';
import {
  Container,
  CompanyDateContainer,
  Value,
  ValueHighlighted,
  List,
  ListItem,
  Date,
} from './template-professional-item.styled';

type Props = {
  DateStyle?: typeof Date;
  $margin: string;
};

export const TemplateProfessionalExperienceItem: React.FC<
  VitaProfessionalExperienceFragment & Props
> = ({
  $margin,
  company,
  occupation,
  startDate,
  endDate,
  isCurrentEmployer,
  descriptions,
  DateStyle,
}) => {
  const intl = useIntl();
  const endDateValue = isCurrentEmployer ? null : endDate;
  const DateComponent = DateStyle ? DateStyle : Date;

  return (
    <Container $margin={$margin}>
      <CompanyDateContainer>
        {company ? <ValueHighlighted>{company}</ValueHighlighted> : null}
        {startDate ? (
          <DateComponent>
            {formatRangeDate(intl, startDate, endDateValue)}
          </DateComponent>
        ) : null}
      </CompanyDateContainer>

      {occupation ? <Value>{occupation}</Value> : null}
      {descriptions ? (
        <List>
          {descriptions.map((description, index) => (
            <ListItem key={index}>{description?.description}</ListItem>
          ))}
        </List>
      ) : null}
    </Container>
  );
};
